export default __webpack_public_path__ + "static/media/reinhardt-barrier.0e99cebd.mp3";